import { render, staticRenderFns } from "./smartlainat.vue?vue&type=template&id=cfdd8624&"
import script from "./smartlainat.vue?vue&type=script&lang=js&"
export * from "./smartlainat.vue?vue&type=script&lang=js&"
import style0 from "./smartlainat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports